<div class="grid my-6">
    <div class="
        col-12
        sm:col-12
        md:col-4
        lg:col-4
        xl:col-5
        ">
        <div class="bg-white border-round-lg text-center">
            <a *ngIf="eventNew.route != ''"  class="p-0 m-0" [routerLink]="eventNew.route"><img [src]="eventNew.image" alt=""  class="block border-round-lg" style="object-fit: cover; max-width: 100%; height: 100%"></a>
        </div>
    </div>
    <div class="
        col-12
        sm:col-12
        md:col-8
        lg:col-8
        xl:col-7
        flex
        flex-column
        lg:justify-content-center
    "
    style="border-bottom: solid 1px #9A9A9A;"
    >
      <h2 style="margin: 0px;">{{ eventNew.title }}</h2>
      <h5 style="overflow: hidden; white-space: nowrap; color: #606060;text-overflow: ellipsis !important;">{{textWithoutTags}}</h5>
      <div class="grid flex justify-content-between px-3">
          <p class="text-sm">{{label}}:  {{date | date}}</p>
          <p-button (click)="sendWithState(eventNew)" label="Ver más" styleClass="p-button-info p-button-text" icon="pi pi-angle-double-right" iconPos="right"></p-button>
      </div>
      <p *ngIf="eventNew.tags!.length > 0">
        Tags: <p-tag *ngFor="let itemTag of eventNew.tags" [style]="{margin: '1.5px', backgroundColor: 'var(--primary-color)'}" value="{{itemTag}}" [rounded]="true"></p-tag>
    </p>
    </div>
</div>
